import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
    PhoneCall,
    SupportActivity,
} from '@myrtls/api-interfaces';

export const getPhoneCallRequestAction = createAction(
    '[Support] Get Phone Call Request',
);

export const getPhoneCallSuccessAction = createAction(
    '[Support] Get Phone Call Success',
    props<{ phoneCall: PhoneCall }>(),
);

export const getPhoneCallFailureAction = createAction(
    '[Support] Get Phone Call Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSiteActivitiesRequestAction = createAction(
    '[Support] Get Site Activities Request',
);

export const getSiteActivitiesSuccessAction = createAction(
    '[Support] Get Site Activities Success',
    props<{ activities: SupportActivity[] }>(),
);

export const getSiteActivitiesFailureAction = createAction(
    '[Support] Get Site Activities Failure',
    props<{ error: HttpErrorResponse }>(),
);
